<div class="c-contenedor">
    <div class="row">
        <div class="col-12 p-0">
            <img class="icon-close pr-10" (click)="onCloseClick()" src="assets/icons/ico-close.png" alt="cerrar">
        </div>
    </div>

    <div class="row">
        <div class="col-12">
            <h1 mat-dialog-title class="c-titulo-dialogo"> ¿Dónde encuentro mi número de serie o documento? </h1>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 auto">
            <p class="tipo-cedula">Cédula nueva</p>
            <img class="imagen-cedula" src="assets/images/group-5.png">
            <p class="descripcion-cedula">Para cédulas posteriores a 2013, el número de serie se encuentra en el anverso
            </p>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 auto">
            <p class="tipo-cedula">Cédula antigua</p>
            <img class="imagen-cedula" src="assets/images/group-5-reversa.png">
            <p class="descripcion-cedula">Para cédulas anteriores a 2013, el número de serie se encuentra al reverso</p>
        </div>
    </div>
</div>